import { useSelector } from "react-redux";
import { EHoldingTypeNCD } from "../Constants/constant";
import { EBuySell } from "../Enum/OTC";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
export function validateTransaction() {
    var _a, _b, _c, _d;
    var _e = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), paymentMode = _e.paymentMode, purchaseFee = _e.purchaseFee, uploadDeclaration = _e.uploadDeclaration, transactionJourney = _e.transactionJourney, transactionDetails = _e.transactionDetails, validateSetUpFees = _e.validateSetUpFees, validateQuantity = _e.validateQuantity;
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var dpDetails = transactionJourney.dpDetails, quantity = transactionJourney.quantity, dirtyPrice = transactionJourney.dirtyPrice;
    var bankName = paymentMode.bankName, rtgsNo = paymentMode.rtgsNo, chequeNo = paymentMode.chequeNo, type = paymentMode.type;
    var isBuyStock = (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag) === EBuySell.Buy &&
        Boolean(paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo);
    var isBuyBankName = (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag) === EBuySell.Buy && Boolean(bankName.value);
    var isBuyDebitStatement = (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag) === EBuySell.Buy &&
        (uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.length) <= 0
        ? false
        : true;
    var isBuySell = (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.buySellFlag) === EBuySell.Sell
        ? true
        : isBuyStock && isBuyBankName && isBuyDebitStatement;
    var isDpDetailsValid = Boolean(dpDetails);
    var isQuantityValid = Boolean(quantity) && ((_a = validateQuantity === null || validateQuantity === void 0 ? void 0 : validateQuantity.data) === null || _a === void 0 ? void 0 : _a.m_status) !== "FAILURE";
    Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.availableQty) >= Number(quantity);
    var isDirtyPriceValid = Boolean(dirtyPrice);
    var isSetupFee = ESubProductIds.StructuredProducts === subCategoryId
        ? Number(purchaseFee.setUpFees) <=
            ((_b = validateSetUpFees === null || validateSetUpFees === void 0 ? void 0 : validateSetUpFees.data) === null || _b === void 0 ? void 0 : _b.max_setupfee_amt)
        : true;
    var isPriceRangeValid = (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.priceRange) &&
        Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.min_sell_price) <= Number(dirtyPrice) &&
        Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.max_sell_price) >= Number(dirtyPrice);
    var passoutValue = (purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout) === "null" ? "" : purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.passout;
    var isSubBroker = (((_c = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _c === void 0 ? void 0 : _c.display_name) && !passoutValue) ||
        (!((_d = purchaseFee === null || purchaseFee === void 0 ? void 0 : purchaseFee.sbName) === null || _d === void 0 ? void 0 : _d.display_name) && passoutValue)
        ? false
        : true;
    var isPaymentModeValid = true;
    var passout = (passoutValue && Number(passoutValue) < 10) || Number(passoutValue) > 85
        ? false
        : true;
    if (!type) {
        isPaymentModeValid = true;
    }
    else {
        switch (type) {
            case EHoldingTypeNCD.RTGS:
                isPaymentModeValid =
                    bankName.value &&
                        rtgsNo &&
                        (rtgsNo === null || rtgsNo === void 0 ? void 0 : rtgsNo.length) >= 3 &&
                        (uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.length) > 0
                        ? true
                        : false;
                break;
            case EHoldingTypeNCD.Cheque:
                isPaymentModeValid =
                    Boolean(bankName.value) &&
                        Boolean(chequeNo) &&
                        Boolean((uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration.length) > 0);
                break;
            case EHoldingTypeNCD.NetBanking:
                isPaymentModeValid = Boolean(bankName.value);
                break;
        }
    }
    return (isDpDetailsValid &&
        isDirtyPriceValid &&
        isPriceRangeValid &&
        isQuantityValid &&
        isBuySell &&
        isPaymentModeValid &&
        isSetupFee &&
        isSubBroker &&
        passout);
}
